import { IState, IMeta, IUi } from '../../interfaces/state';
import * as Actions from '../../actions/';
import * as ReactRedux from 'react-redux';
import * as React from 'react';
import * as Redux from 'redux';
import { TabContent, ITabContentProps } from '../../components/tab';

export interface ITabStateProps extends ITabContentProps {
    readonly meta: IMeta;
    readonly ui: IUi;
}

function mapDispatchToProps(dispatch: Redux.Dispatch<any>): any {
    return {
        ...Redux.bindActionCreators({
            ...Actions.UI.Creators,
        }, dispatch),
    };
}

function mapStateToProps(state: IState, props: ITabContentProps): ITabStateProps {
    return {
        ...props,
        meta: state.meta,
        ui: state.ui,
        values: state.values
    };
}
export const TabContainer: React.ComponentClass<any>
    = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(TabContent);
